<template>
  <v-container class="pa-0 ma-0">
    <v-card class="pa-4 ma-0">
      <!-- Global info-->
      <v-container class="chart-header d-flex justify-space-between pa-0 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("module_overall_performance") }}
        </v-card-text>
      </v-container>
      <!-- spider info-->
      <apexchart
        type="radar"
        height="350"
        :options="chartOptions"
        :series="chartSeries"
      />
    </v-card>
  </v-container>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    purchaseData: {
      type: [Number, String, Object],
      required: true,
    },
    sellData: {
      type: [Number, String, Object],
      required: true,
    },
    warehouseData: {
      type: [Array, Object],
      required: true,
    },
    crmData: {
      type: [Array, Object],
      required: true,
    },
    costData: {
      type: [Array, Object],
      required: true,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "radar",
          toolbar: { show: false },
          fontFamily: "IRANSans",
        },

        xaxis: {
          categories: ["فروش", "خرید", "انبار", "هزینه‌ها", "خزانه", "CRM"],
          labels: {
            style: {
              fontSize: "11px",
            },
          },
        },

        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 4,
        },

        stroke: {
          width: 2,
        },

        fill: {
          opacity: 0.45,
        },

        colors: ["#8B5CF6"],

        markers: {
          size: 0,
        },

        grid: {
          show: true,
        },

        plotOptions: {
          radar: {
            size: 110,
            polygons: {
              strokeColors: "#E5E7EB",
              connectorColors: "#E5E7EB",
              fill: {
                colors: ["#ffffff"],
              },
            },
          },
        },

        tooltip: {
          y: {
            formatter: (val) => `${val}%`,
          },
        },

        legend: {
          show: false,
        },
      },
    };
  },
  computed: {
    chartSeries() {
      const rawValues = [
        Number(this.sellData?.current) || 0,
        Number(this.purchaseData?.current) || 0,
        Number(this.warehouseData?.current?.total_balance_value) || 0,
        Number(this.costData?.current) || 0,
        0,
        Number(this.crmData?.current) || 0,
      ];
      return [
        {
          name: "عملکرد",
          data: [100, 100, 100, 100, 100, 60],
        },
      ];
    },
  },
};
</script>

<style scoped>
.chart-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
